import {
  isLoggedIn,
  isVendorLoggedIn,
  logout,
  vendorLogout,
} from "./login/loginService";
import { ASaveQueryData } from "./login/loginApiService";
import { config } from "../config/domain";

export function handleSessionTimeout(newResp: Response, res: any) {
  if (
    newResp.status === 403 ||
    (newResp.status === 401 && (isLoggedIn() || isVendorLoggedIn())) ||
    (newResp.status === 200 &&
      res.response &&
      res.response.infoID === "EPS0008")
  ) {
    logout();
    vendorLogout();

    if (sessionStorage.getItem("source")) {
      sessionStorage.removeItem("source");
      sessionStorage.removeItem("sourceToken");
    }

    let queryString;
    window.location.href = config.root;
    ASaveQueryData(getToken, JSON.stringify(queryString));
  }
}

function getToken(res: any) {
  if (res.data) {
    window.location.href =
      process.env.PUBLIC_URL + "/login?token=" + res.data.token;
  }
}
